import styled from 'styled-components'
import {media} from "@/styles/Qtheme.ts";
import { MobileCalVW, TabletCalVW } from '@utils/CalVW.tsx';

export const PageMenuTabSection = styled.div`
	height: 51px;
    width: 1200px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
    overflow-x: scroll;
    overflow-y: hidden;
    scrollbar-width: none;


    @media ${media.desktop} {
        width: ${TabletCalVW(900)};
    }

    @media ${media.mobile} {
        height: auto;
        justify-content: flex-start;
        align-items: flex-start;
    }
`
export const PageMenuSection = styled.div`
	width: 1200px;
	display: flex;
	align-items: center;
	justify-content: center;

    @media ${media.desktop} {
        width: ${TabletCalVW(900)};
    }

    @media ${media.mobile} {
        width: auto;
    }
`
